import { render, staticRenderFns } from "./GuestInfo.vue?vue&type=template&id=226f0238&scoped=true"
import script from "./GuestInfo.vue?vue&type=script&lang=js"
export * from "./GuestInfo.vue?vue&type=script&lang=js"
import style0 from "./GuestInfo.vue?vue&type=style&index=0&id=226f0238&prod&lang=less&scoped=true"
import style1 from "./GuestInfo.vue?vue&type=style&index=1&id=226f0238&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f0238",
  null
  
)

export default component.exports